export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6531.98fdb711.jpg";